// @flow
import {parseURL} from '@homeaway/search-url-parser';
import type {SearchRequest} from '@homeaway/search-url-parser';
import searchParamActions from '../../actions/searchParams';
import {getUri} from '../../utils/routerUtils';

import type {ConnectedReactRouterLocationAction} from '../../actions/types';
import type {Store} from '../../reducers/index';

export const defaultIfUndefined = (param?: any, defaultValue: any) => {
    return typeof param === 'undefined' ? defaultValue : param;
};

export const parseSearchParams = (
    store: Store,
    action: ConnectedReactRouterLocationAction
) => {
    const {siteName} = store.getState().system;
    const {pathname, search} = action.payload.location;

    // we have to add 'search' since 'pathname' doesn't include the query string
    const paramsFromGT: SearchRequest = parseURL(getUri({pathname, search}), {
        name: siteName
    });

    /* Update our state to match the new cookie */
    store.dispatch(
        searchParamActions.setSearchParams({pathname, params: paramsFromGT})
    );
};
